import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { URL } from "../Redux/common/url";

function Slider() {
  const slider_list = useSelector((state) => state?.allapi?.slider_list || {});

  const images = slider_list?.sliders
    ? slider_list.sliders.map((item) => URL.API_BASE_URL + item.image)
    : [];

  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (!images.length) return;

    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [images]);

  if (!images.length) return null;

  return (
    <>
      <div
        style={{
          width: "100%",
          height: "45vw",
          maxHeight: "500px",
          minHeight: "220px",
          overflow: "hidden",
        }}
      >
        <img
          src={images[currentIndex]}
          alt="slider"
          style={{
            width: "100%",
            height: "100%",
            // objectFit: "cover",        // ✅ FULL WIDTH
            objectPosition: "center",  // 👉 change if needed
          }}
        />
      </div>
    </>
  );
}

export default Slider;